import React from 'react';
import './Footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_content">
                <div className="footer_copyright">
                    <p>&copy; 2025 sd-studio. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
